import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';

import { ApolloMutationService } from '../../shared/apollo/index';
import { FormHandlerService } from '../../shared/forms/index';
import { MessageService } from '../../shared/message/index';
import { GlobalService } from '../../shared/global/index';
import { ExtendedFormGroup } from 'app/shared/forms/extended-form-group';

@Component({
  selector: 'project-default-todo-row',
  templateUrl: 'project-default-todo-row.component.html',
  providers: [FormHandlerService],
})
export class ProjectDefaultTodoRowComponent implements OnInit {
  @Input() dataObjectFromParent;
  @Input() usersDropdown;
  @Output() defaultTodoSaveToProject = new EventEmitter();
  @Output() updateRow = new EventEmitter();
  @Output() estimatedTimeChange = new EventEmitter();

  dataModel = 'projectDefualtTodo';
  dataModelCapitalized = 'ProjectDefualtTodo';
  buttons;
  text: string;
  results = [];
  userTodoRelations = [];
  saveToProject: boolean;
  loading = false;
  componentPrefix: number;
  avtalspris: string = null;
  defaultForAllProjects: boolean;
  public componentMainForm: ExtendedFormGroup;
  formFields = {
    model: this.dataModelCapitalized,
  };

  constructor(
    private formHandler: FormHandlerService,
    private messageService: MessageService,
    private globalService: GlobalService,
    private mutationService: ApolloMutationService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {
    this.setCheckbox();

    const buttonObject = {
      update: {
        model: this.dataModel,
      },
      delete: {
        model: this.dataModel,
      },
    };

    this.buttons = this.formHandler.getButtonValues(buttonObject);
    this.componentPrefix = this.globalService.generateComponentPrefix();
    this.formFields['attributes'] = this.setFieldsForForm();
    this.formInit();
  }

  formInit() {
    this.componentMainForm = this.formHandler.groupedFormSimple(
      this.formFields
    );
    this.formHandler
      .groupSetLabelsRules(this.formFields, this.componentMainForm)
      .then();
  }

  setFieldsForForm() {
    const attributes = new Object();
    for (const dataObjectIndex in this.dataObjectFromParent) {
      const keyValue = this.dataObjectFromParent[dataObjectIndex];
      attributes[dataObjectIndex] = keyValue;
    }
    delete attributes['topic'];
    delete attributes['offerId'];
    delete attributes['descriptionOffer'];
    delete attributes['type'];
    delete attributes['todoType'];
    delete attributes['__typename'];
    return attributes;
  }

  setCheckbox() {
    if (this.dataObjectFromParent.defaultForAllProjects > 0) {
      this.defaultForAllProjects = true;
    } else {
      this.defaultForAllProjects = false;
    }
  }

  setSaveToProject(defaultForAllProjectsBool) {
    if (!defaultForAllProjectsBool) {
      this.saveToProject = false;
    }
  }

  defaultTodoSaveToProjectEmit(todoObj) {
    this.defaultTodoSaveToProject.emit(todoObj);
  }

  actionUpdate() {
    const crudType = 'update';
    const dataToMutation = this.getMutationDataFromForm();

    this.buttons = this.formHandler.lockButtons(this.buttons);

    if (!this.formHandler.formValid([this.componentMainForm])) {
      this.buttons = this.formHandler.unlockButtons(this.buttons);
    } else {
      this.loading = true;
      const refetchArr = [{ name: 'projectDefaultTodos', variables: null }];
      const executeMutationSub = this.mutationService
        .constructQueryAndExecuteMutation(
          this.dataModel,
          crudType,
          false,
          dataToMutation,
          null,
          refetchArr
        )
        .subscribe(
          executedData => {
            this.mutationService.displayMutationStatus(executedData);

            this.formHandler.showServerErrorsOnAttributes(executedData, [
              {
                form: this.componentMainForm,
                argument: crudType + this.dataModelCapitalized,
              },
            ]);

            this.loading = false;

            this.buttons = this.formHandler.unlockButtons(this.buttons);

            executeMutationSub.unsubscribe();
          },
          err => {
            console.log(err);
            this.buttons = this.formHandler.unlockButtons(this.buttons);
          }
        );
    }
  }

  confirmDeleteTodo() {
    this.confirmationService.confirm({
      message: 'Är du säker på att du vill ta bort arbetsmomentet?',
      header: 'Bekräfta val',
      icon: 'fa fa-trash',
      accept: () => {
        this.buttons = this.formHandler.lockButtons(this.buttons);
        this.deleteTodo();
      },
      reject: () => {},
    });
  }

  private deleteTodo() {
    const crudType = 'delete';
    const dataToMutation = { id: Number(this.dataObjectFromParent.id) };
    const refetchArr = [{ name: 'projectDefaultTodos', variables: null }];
    const executeMutationSub = this.mutationService
      .constructQueryAndExecuteMutation(
        this.dataModel,
        crudType,
        false,
        dataToMutation,
        null,
        refetchArr
      )
      .subscribe(
        executedData => {
          this.mutationService.displayMutationStatus(executedData);

          this.formHandler.showServerErrorsOnAttributes(executedData, [
            {
              form: this.componentMainForm,
              argument: crudType + this.dataModelCapitalized,
            },
          ]);

          if (!executedData.mutationSucceededAllArguments) {
            this.buttons = this.formHandler.unlockButtons(this.buttons);
          }

          executeMutationSub.unsubscribe();
        },
        err => {
          console.error(err);
          this.buttons = this.formHandler.unlockButtons(this.buttons);
        }
      );
  }

  addUser(event) {
    let userExistInTodoRelation = false;
    for (const i in this.userTodoRelations) {
      const userTodoRelation = this.userTodoRelations[i];

      if (Number(event['value']) === userTodoRelation['userId']) {
        userExistInTodoRelation = true;
      }
    }

    if (!userExistInTodoRelation) {
      this.createUserTodoRelation(event['value']);
    }
  }

  addEmittedUserTodoRelation(emittedObj) {
    const userTodoRelation = {
      id: +emittedObj['id'],
      userId: emittedObj['userId'],
      todoId: emittedObj['todoId'],
    };
    this.userTodoRelations.push(userTodoRelation);
  }

  deleteEmittedUserTodoRelation(userTodoRelationIdParam) {
    const relaId = Number(userTodoRelationIdParam);

    for (const index in this.userTodoRelations) {
      const relation = this.userTodoRelations[index];

      if (Number(relation['id']) === relaId) {
        this.userTodoRelations.splice(+index, 1);
        break;
      }
    }
  }

  getUserName(userId) {
    let username: string;

    for (const index in this.usersDropdown) {
      const user = this.usersDropdown[index];

      if (Number(user['value']) === Number(userId)) {
        username = user['label'];
      }
    }

    return username;
  }

  createUserTodoRelation(userIdParam) {
    const crudType = 'create';
    const dataToMutation = {
      todoId: Number(this.dataObjectFromParent['id']),
      userId: userIdParam,
    };

    const returnArgs = ['id', 'userId', 'todoId'];
    this.buttons = this.formHandler.lockButtons(this.buttons);

    const executeMutationSub = this.mutationService
      .constructQueryAndExecuteMutation(
        'userTodoRelation',
        crudType,
        false,
        dataToMutation,
        returnArgs
      )
      .subscribe(
        executedData => {
          if (executedData.mutationSucceededAllArguments) {
            this.addEmittedUserTodoRelation(executedData);
          }
          this.mutationService.displayMutationStatus(executedData);

          this.buttons = this.formHandler.unlockButtons(this.buttons);
          executeMutationSub.unsubscribe();
        },
        err => {
          console.log(err);
          this.buttons = this.formHandler.unlockButtons(this.buttons);
        }
      );
  }

  utslagUserHoursTooltips() {
    let tooltip =
      '<table><tr><td style="padding-right:15px"><strong>Användare</strong></td><td><strong>Timmar</strong></td></tr>';

    for (const index in this.dataObjectFromParent['utslag']['users']) {
      const user = this.dataObjectFromParent['utslag']['users'][index];
      tooltip +=
        '<tr><td style="padding-right:15px">' +
        user['username'] +
        '</td><td>' +
        user['hours'] +
        '</td></tr>';
    }

    tooltip += '</table>';

    return tooltip;
  }

  deleteUserTodoRelation(relationIdParam) {
    const relationId = relationIdParam;
    this.confirmDeleteUserTodoRelationMutation(relationId);
  }

  confirmDeleteUserTodoRelationMutation(idParam) {
    this.confirmationService.confirm({
      message: 'Är du säker på att du vill ta bort knytningen?',
      header: 'Bekräfta val',
      icon: 'fa fa-trash',
      accept: () => {
        this.buttons = this.formHandler.lockButtons(this.buttons);
        this.deleteUserRelationMutation(idParam);
      },
      reject: () => {},
    });
  }

  private deleteUserRelationMutation(idParam: any) {
    const crudType = 'delete';
    const dataToMutation = { id: Number(idParam) };
    const executeMutationSub = this.mutationService
      .constructQueryAndExecuteMutation(
        'userTodoRelation',
        crudType,
        false,
        dataToMutation
      )
      .subscribe(
        executedData => {
          if (executedData.mutationSucceededAllArguments) {
            this.deleteEmittedUserTodoRelation(idParam);
          }
          this.mutationService.displayMutationStatus(executedData);
          this.buttons = this.formHandler.unlockButtons(this.buttons);
          executeMutationSub.unsubscribe();
        },
        err => {
          this.messageService.insertData({ textArray: [err], type: 'error' });
          this.buttons = this.formHandler.unlockButtons(this.buttons);
        }
      );
  }

  getMutationDataFromForm() {
    const dataObjectToMutation = {};

    for (const control in this.componentMainForm.controls) {
      dataObjectToMutation[control] =
        '' + this.componentMainForm.controls[control].value;
    }

    dataObjectToMutation['id'] = Number(dataObjectToMutation['id']);

    if (this.defaultForAllProjects) {
      dataObjectToMutation['defaultForAllProjects'] = 1;
    } else {
      dataObjectToMutation['defaultForAllProjects'] = '';
    }

    delete dataObjectToMutation['__typename'];
    delete dataObjectToMutation['days'];

    return dataObjectToMutation;
  }

  clearRow() {
    this.formInit();
  }

  updateRowEmit(emittedObj) {
    const todoObj = {
      id: emittedObj['id'],
      description: emittedObj['description'],
    };
    this.updateRow.emit(todoObj);
  }
}
